// extracted by mini-css-extract-plugin
export default {"container":"goback_container__D0qwb","containers":"goback_containers__7m9YG","button":"goback_button__3x9VS","buttons":"goback_buttons__Y+Ba0"};